import axios from "axios"

import Lightbox from "./Lightbox"

export default class ProductForm {
  constructor() {
    this.form = document.querySelector("#product-form")
    this.addToCartBtn = document.querySelector("#add-to-cart")
    this.subscriptionProductId = document.querySelector("#subscription-product-id")

    this.productAddedBtn = document.querySelector(".open-added-lightbox")
    this.cartItemsCountElements = document.querySelectorAll(".cart-items-count")

    this.form.addEventListener("submit", this.handleSubmit.bind(this))

    if (this.productAddedBtn) {
      this.lightbox = new Lightbox('#product-added-lightbox')

      return
    }

    if (this.addToCartBtn.dataset.lightboxTarget) {
      this.addToCartBtn.addEventListener("click", this.handleConfirm.bind(this))

      this.lightbox = new Lightbox(this.addToCartBtn.dataset.lightboxTarget)

      return
    }
  }

  handleConfirm(event) {
    event.preventDefault()

    this.lightbox.open()
  }

  handleSubmit(event) {
    event.preventDefault()

    let formData = new FormData(this.form)

    if (this.lightbox) this.lightbox.close()

    this.addToCartBtn.setAttribute("disabled", "disabled")

    if (this.subscriptionProductId) {
      formData.set("id", this.subscriptionProductId.value)
    }

    axios.post("/cart/add.js", formData).then((response) => {
      this.handleUpdateCart(response.data)
    }).catch(() => {
      this.addToCartBtn.removeAttribute("disabled")
    })
  }

  handleUpdateCart(item) {
    const itemTitle = item.title

    axios.get("/cart.js").then((response) => {
      for (let cartItemCount of this.cartItemsCountElements) {
        cartItemCount.innerText = response.data.item_count
      }

      if (this.productAddedBtn) {
        this.lightbox.open()
      }

      this.addToCartBtn.removeAttribute("disabled")
    })
  }
}
